var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-upload',{key:_vm.$root.$session.versao})}
var staticRenderFns = []

export { render, staticRenderFns }